/* Bandeau de consentement — branché sur l'API officielle Shopify (Shopify.customerPrivacy).
   Affiché si shouldShowBanner() le demande ET qu'AUCUN consentement n'est enregistré (currentVisitorConsent()
   aux valeurs vides) — décision du contrôleur, 02/10. shouldShowBanner() ne suffit PAS seul : mesuré le 02/10 depuis la France, il répond `true` même APRÈS
   un refus enregistré (et après rechargement) — s'y fier ferait réapparaître le bandeau à chaque page.
   Un clic écrit le choix via setTrackingConsent() ; le bandeau se masque quand Shopify a répondu sans erreur.
   Le bandeau natif (#shopify-pc__banner) est masqué en CSS dans ce thème (jamais deux bandeaux) ; si l'API
   ne se charge pas, la classe `moola-cookies-repli` sur <html> lui rend la main pour que le choix reste possible. */
(function () {
  var bandeau = document.querySelector('.moola-cookies');
  if (!bandeau) { return; }
  /* « Gérer mes cookies » : tout élément [data-moola-cookies-ouvrir] (ex. sur /pages/cookies) rouvre le bandeau,
     même si un choix est déjà enregistré — retirer son accord doit être aussi simple que le donner (RGPD art. 7.3).
     Tant que l'API n'est pas prête, le clic est mémorisé et servi dès qu'elle l'est. */
  var pret = false, demande = false;
  function ouvrir() { if (pret) { bandeau.hidden = false; var b = bandeau.querySelector('button'); if (b) { b.focus(); } } else { demande = true; } }
  document.addEventListener('click', function (e) {
    var lien = e.target.closest && e.target.closest('[data-moola-cookies-ouvrir]');
    if (!lien) { return; }
    e.preventDefault();
    ouvrir();
  });
  function repli() { document.documentElement.classList.add('moola-cookies-repli'); }
  if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { repli(); return; }

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (erreur) {
    var cp = window.Shopify.customerPrivacy;
    if (erreur || !cp || typeof cp.setTrackingConsent !== 'function' || typeof cp.currentVisitorConsent !== 'function') { repli(); return; }

    var consentement = cp.currentVisitorConsent() || {};
    var vide = Object.keys(consentement).every(function (cle) { return consentement[cle] === ''; });
    var requis = typeof cp.shouldShowBanner === 'function' ? cp.shouldShowBanner() : true;

    var boutons = bandeau.querySelectorAll('button');
    function repondre(valeur) {
      for (var i = 0; i < boutons.length; i++) { boutons[i].disabled = true; }
      cp.setTrackingConsent({ analytics: valeur, marketing: valeur, preferences: valeur, sale_of_data: valeur }, function (r) {
        for (var i = 0; i < boutons.length; i++) { boutons[i].disabled = false; }
        if (r && r.error) { return; }
        bandeau.hidden = true;
      });
    }
    var refuser = bandeau.querySelector('[data-refuser]'), accepter = bandeau.querySelector('[data-accepter]');
    if (refuser) { refuser.addEventListener('click', function () { repondre(false); }); }
    if (accepter) { accepter.addEventListener('click', function () { repondre(true); }); }
    pret = true;
    if (demande || (requis && vide)) { bandeau.hidden = false; }
  });
})();
